import { render, staticRenderFns } from "./CourseMaterialVideoDialog.vue?vue&type=template&id=26168032&"
import script from "./CourseMaterialVideoDialog.vue?vue&type=script&lang=ts&"
export * from "./CourseMaterialVideoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
